import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { useToast } from "../../commoncomponents/ToastProvider";

const SubProfile = () => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: ""
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [passwordData, setPasswordData] = useState({
    new_password: "",
    confirm_password: ""
  });
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const cookie = new Cookies();
  const { showToast } = useToast();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/subadmin/profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: cookie.get("subadmin"),
        }),
      });
      const data = await response.json();
      if (data.status) {
        setProfile(data.data);
      } else {
        showToast("Failed to load profile", "error");
      }
    } catch (error) {
      showToast("Network error", "error");
    }
  };

  const handleProfileUpdate = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/subadmin/updateprofile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: cookie.get("subadmin"),
          email: profile.email,
        }),
      });
      const data = await response.json();
      if (data.status) {
        showToast("Profile updated successfully", "success");
        setIsEditMode(false);
      } else {
        showToast(data.error?.msg || "Failed to update profile", "error");
      }
    } catch (error) {
      showToast("Network error", "error");
    }
  };

  const handlePasswordChange = async () => {
    if (passwordData.new_password !== passwordData.confirm_password) {
      showToast("New passwords don't match", "error");
      return;
    }
    if (passwordData.new_password.length < 6) {
      showToast("Password must be at least 6 characters", "error");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/subadmin/changepassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: cookie.get("subadmin"),
          new_password: passwordData.new_password,
        }),
      });
      const data = await response.json();
      if (data.status) {
        showToast("Password changed successfully", "success");
        setPasswordData({ new_password: "", confirm_password: "" });
        setShowPasswordForm(false);
      } else {
        showToast(data.error?.msg || "Failed to change password", "error");
      }
    } catch (error) {
      showToast("Network error", "error");
    }
  };

  return (
    <>
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <h2>Subadmin Profile</h2>
          <table className="options_table">
            <tr>
              <td className="bold min_width">Name : </td>
              <td>{profile.name}</td>
            </tr>
            <tr>
              <td className="bold min_width">Mobile Number : </td>
              <td>{profile.phone}</td>
            </tr>
            <tr>
              <td className="bold min_width">Email : </td>
              <td>{profile.email}</td>
            </tr>
          </table>

          <div className="btn_container">
            <button onClick={() => setShowPasswordForm(!showPasswordForm)}>
              {showPasswordForm ? "Cancel" : "Change Password"}
            </button>
          </div>

          {showPasswordForm && (
            <div className="password_form">
              <h3>Change Password</h3>
              <table className="options_table">
                <tr>
                  <td className="bold min_width">New Password : </td>
                  <td>
                    <input
                      type="password"
                      value={passwordData.new_password}
                      onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="bold min_width">Confirm Password : </td>
                  <td>
                    <input
                      type="password"
                      value={passwordData.confirm_password}
                      onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
                    />
                  </td>
                </tr>
              </table>
              <div className="btn_container">
                <button onClick={handlePasswordChange}>Update Password</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SubProfile;
